import { useMemo } from "react";
import { DateRangePicker as MuiDateRangePicker } from "@mui/x-date-pickers-pro/DateRangePicker";
import type { DateRangePickerProps, DateRangePickerSlotProps } from "@mui/x-date-pickers-pro/DateRangePicker";
import { alpha, useTheme } from "@mui/material";

function DateTimePicker(props: DateRangePickerProps) {
  const { slotProps, ...rest } = props;

  const theme = useTheme();

  const multiInputDateRangeFieldProps = useMemo<DateRangePickerSlotProps<false>>(() => {
    return {
      ...slotProps,
      day: {
        ...slotProps?.day,
        sx: {
          "& .MuiDateRangePickerDay-rangeIntervalPreview": {
            "& .Mui-selected, & .Mui-selected:hover": {
              backgroundColor: theme.palette.secondary.main,
              color: theme.palette.getContrastText(theme.palette.secondary.light),
            },
          },
          "&.MuiDateRangePickerDay-rangeIntervalDayHighlight": {
            backgroundColor: alpha(theme.palette.secondary.light, 0.25),
            color: theme.palette.getContrastText(alpha(theme.palette.secondary.light, 0.25)),
          },
        },
      },
    };
  }, [slotProps, theme.palette]);

  return <MuiDateRangePicker {...rest} slotProps={multiInputDateRangeFieldProps} />;
}

export default DateTimePicker;
